// This file is generated by pnpm icons:generate. Do not edit.

import {createSinglePathSVG} from './TEMPLATE'

export const MusicNote_Stroke2_Corner0_Rounded = createSinglePathSVG({
  path: 'm19.716 5.282-7.5-2.25a.75.75 0 0 0-.966.718V13.9a4.5 4.5 0 1 0 1.5 3.35V9.258l6.534 1.96a.75.75 0 0 0 .966-.718V6a.75.75 0 0 0-.534-.718ZM8.25 20.25a3 3 0 1 1 3-3 3 3 0 0 1-3 3Zm10.5-10.758-6-1.8V4.758l6 1.805Z',
  viewBox: '0 0 24 24',
  glyph: 'MusicNote_Stroke2_Corner0_Rounded',
})
